import React, { useState } from 'react';
import iconBr from '../../assets/imgs/br.webp'
import iconEn from '../../assets/imgs/en.webp'
import iconEs from '../../assets/imgs/es.webp'
import Logo from '../../assets/imgs/logo_mig.png'


export default function Navbar({ lang }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <div className='bg-primary fixed w-screen top-0 h-28 flex items-center'>
      <div className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
        <nav className='flex justify-between items-center'>
          <a href="/">
            <img src={Logo} alt="Migplus" />
          </a>
          <section className='flex lg:hidden'>
            <div className='space-y-2' onClick={() => setIsMenuOpen((prev) => !prev)}>
              <span className="block h-0.5 w-8 bg-white"></span>
              <span className="block h-0.5 w-8 bg-white"></span>
              <span className="block h-0.5 w-8 bg-white"></span>
            </div>
            <div className={isMenuOpen ? "flex absolute w-full top-28 left-0 bg-primary z-10 flex-col justify-around animate-slide-down" : "hidden"}>
              <ul className='gap-8 text-white uppercase flex flex-col items-end m-8 mr-16'>
                {showMenu(lang)}
              </ul>
            </div>
          </section>

          <ul className='gap-4 lg:items-center font-semibold text-white uppercase hidden lg:flex'>
            {showMenu(lang)}
          </ul>
        </nav>
      </div>
    </div>
  )
};

const showMenu = (lang) => {
  switch (lang) {
    case 'en':
      return (
        <>
          <li>
            <a href="/en/home">home</a>
          </li>
          <li>
            <a href="/en/new">create</a>
          </li>
          <li >
            <a href="/en/follow">follow</a>
          </li>
          <li>
            <a href="https://www.migplus.com.br">back to website</a>
          </li>
          <li className='text-hover'>
            <a href="/"><img src={iconBr} alt="PT_br" /></a>
          </li>
          <li className='text-hover'>
            <a href="/es/inicial"><img src={iconEs} alt="ES" /></a>
          </li>
        </>
      )
    case 'esp':
      return (
        <>
          <li>
            <a href="/es/inicio">inicio</a>
          </li>
          <li>
            <a href="/es/novo">hacer</a>
          </li>
          <li >
            <a href="/es/consultar">seguir</a>
          </li>
          <li>
            <a href="https://www.migplus.com.br">volver al sitio</a>
          </li>
          <li className='text-hover'>
            <a href="/en/home"><img src={iconEn} alt="EN" /></a>
          </li>
          <li className='text-hover'>
            <a href="/"><img src={iconBr} alt="PT_br" /></a>
          </li>
        </>
      )
    default:
      return (
        <>
          <li>
            <a href="/">início</a>
          </li>
          <li>
            <a href="/new">criar</a>
          </li>
          <li >
            <a href="/follow">acompanhar</a>
          </li>
          <li>
            <a href="https://www.migplus.com.br">voltar ao site</a>
          </li>
          <li className='text-hover'>
            <a href="/en/home"><img src={iconEn} alt="EN" /></a>
          </li>
          <li className='text-hover'>
            <a href="/es/inicial"><img src={iconEs} alt="ES" /></a>
          </li>
        </>
      )
  }
}